
import Split from '../layouts/Split'

import LearningImage from '../../assets/images/home-page/Learning.png'
  
  export default function LearningSection() {
    return (
      <div className="learn-section">
        <Split
            img={LearningImage}
            imgAlt=''
            className='column-reverse'
            title1='Be Informed'
            title2='through education'
            description='Learn how to be a better ally through our learning modules created by experts.'
            buttonText='Learn'
            buttonUrl='/learn'
        />
      </div>
    );
  }